import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        VBtn,
        {
          staticClass: "pa-0",
          attrs: {
            color: "primary",
            small: "",
            depressed: "",
            disabled: _vm.disabled,
            loading: _vm.busyImporting,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.initiateModal()
            },
          },
        },
        [
          _c(VIcon, { attrs: { small: "" } }, [_vm._v("$import")]),
          _vm._v(" "),
          _c("span", { staticClass: "pl-1" }, [
            _vm._v(
              _vm._s(_vm.$t("settings.similarityGroups.upload.uploadButton"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VDialog,
        {
          attrs: { width: "500" },
          model: {
            value: _vm.uploadDialog,
            callback: function ($$v) {
              _vm.uploadDialog = $$v
            },
            expression: "uploadDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                {
                  staticClass: "headline lighten-2",
                  attrs: { "primary-title": "" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("settings.similarityGroups.upload.dialogHeading")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                VIcon,
                {
                  staticClass: "close-button",
                  attrs: { color: "grey" },
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [_vm._v("close")]
              ),
              _vm._v(" "),
              _vm.isInitial
                ? _c("file-upload", {
                    attrs: {
                      "upload-field-name": _vm.uploadFieldName,
                      "is-saving": _vm.isSaving,
                      "tool-store-group-independent": true,
                      source: "similarityGroups",
                    },
                    on: { save: _vm.save },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isValidated
                ? _c(
                    "div",
                    [
                      _c(
                        VCardText,
                        { staticClass: "py-0" },
                        [
                          _c(VContainer, { attrs: { fluid: "" } }, [
                            _c("div", { staticClass: "dialog-body" }, [
                              _c("p", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "settings.similarityGroups.upload.summary"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "mb-3" }, [
                                _c("li", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "settings.similarityGroups.upload.groupsCreated",
                                          _vm.summary.groupsCreated,
                                          {
                                            count: _vm.summary.groupsCreated,
                                          }
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "settings.similarityGroups.upload.productsAssigned",
                                          _vm.summary.productsAssigned,
                                          {
                                            count: _vm.summary.productsAssigned,
                                          }
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$tc(
                                          "settings.similarityGroups.upload.productsReassigned",
                                          _vm.summary.productsReassigned,
                                          {
                                            count:
                                              _vm.summary.productsReassigned,
                                          }
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "settings.similarityGroups.upload.confirmUpload"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(VDivider),
                      _vm._v(" "),
                      _c(
                        VCardActions,
                        [
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "dialog-button",
                              attrs: {
                                color: "primary",
                                outlined: "",
                                depressed: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.closeModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("actions.cancel")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            VTooltip,
                            {
                              attrs: { disabled: !_vm.hasNoChanges, top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({ staticClass: "ml-2" }, on),
                                          [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass:
                                                  "primary dialog-button",
                                                attrs: {
                                                  depressed: "",
                                                  disabled:
                                                    _vm.isUploading ||
                                                    _vm.hasNoChanges,
                                                  loading: _vm.busyImporting,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.confirm()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("actions.upload")
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3803324273
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "settings.similarityGroups.upload.nothingToUpload"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUploading
                ? _c(
                    "div",
                    [
                      _c(
                        VCardText,
                        { staticClass: "py-0" },
                        [
                          _c(VContainer, { attrs: { fluid: "" } }, [
                            _c("div", { staticClass: "dialog-body" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.similarityGroups.upload.uploadingState"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isFailed && _vm.uploadError
                ? _c(
                    "div",
                    [
                      _c(
                        VCardText,
                        [
                          _c(
                            VContainer,
                            [
                              _vm.hasTooManyRows
                                ? _c("div", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "settings.similarityGroups.upload.tooManyRows",
                                            { maxRows: _vm.maxRows }
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasUnknownProductKeyDisplays
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.unknownProductKeyDisplays"
                                      ),
                                      details:
                                        _vm.uploadError
                                          .unknownProductKeyDisplays,
                                      "unique-key-prefix":
                                        "unknownProductKeyDisplays",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasMissingCannGroupProducts
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.missingCannGroupProducts"
                                      ),
                                      details:
                                        _vm.uploadError
                                          .missingCannGroupProducts,
                                      "unique-key-prefix":
                                        "missingCannGroupProducts",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasEmptySimGroupDescriptions
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.emptySimGroupDescriptions"
                                      ),
                                      details:
                                        _vm.uploadError
                                          .emptySimGroupDescriptions,
                                      "unique-key-prefix":
                                        "emptySimGroupDescriptions",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasCannGroupMismatchProducts
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.cannGroupMismatchProducts"
                                      ),
                                      details:
                                        _vm.uploadError
                                          .cannGroupMismatchProducts,
                                      "unique-key-prefix":
                                        "cannGroupMismatchProducts",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasUomMismatchProducts
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.uomMismatchProducts"
                                      ),
                                      details:
                                        _vm.uploadError.uomMismatchProducts,
                                      "unique-key-prefix":
                                        "uomMismatchProducts",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasMissingColumns
                                ? _c("upload-error-card", {
                                    attrs: {
                                      "error-message": _vm.$t(
                                        "settings.similarityGroups.upload.missingColumns"
                                      ),
                                      details: _vm.uploadError.missingColumns,
                                      "unique-key-prefix": "missingColumns",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(VDivider),
                      _vm._v(" "),
                      _c(
                        VCardActions,
                        { staticClass: "btn-group" },
                        [
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(
                            VBtn,
                            {
                              staticClass: "primary",
                              attrs: { depressed: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.closeModal()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("actions.close")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }